// @flow
import React, { type Node, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Header } from 'app/common/layouts/RowLayout';
import SimpleDate from 'app/dataProviders/SimpleDate';
import type { Klass } from 'app/dataTypes/Klasses.types';

import useStudentFirstNameGenitive from './useStudentFirstNameGenitive';


type Props = {
  studentId: string,
  date: SimpleDate,
  klass: Klass,
  currentPeriodTitle: string,
}

const JournalHeader = ({ studentId, date, klass, currentPeriodTitle }: Props): Node => {
  const { t } = useTranslation('dnevnik');
  const name = useStudentFirstNameGenitive(studentId);

  const header = useMemo(() => {
    const part1 = t('journal_header_month_part1', { name, month: date.getString('MMMM') });
    const part2 = t('journal_header_part2', {
      currentPeriod: currentPeriodTitle,
      year: klass.schoolyearTitle,
      klass: klass.title,
    });
    return `${part1} ${part2}`;
  }, [name, t, date, currentPeriodTitle, klass.schoolyearTitle, klass.title]);

  return (
    <Header>{header}</Header>
  );
};

export default JournalHeader;
